angular.module('ihestiaWidgets.pza')
  .directive('ihestiaPzaModalsInjector', [function(){
    return {
      controller: 'ihestiaPzaModalsInjectorCtrl',
      restrict: 'E',
      scope: true,
      templateUrl: 'ihestia-widgets-templates-app/pza/common/modalsInjector.tpl.html'
    };
  }]);